import * as React from 'react'
import Wait from "../wait";
import ReadService from "../../service/read";
import PopDetail from "../popdetail";
import PlotDetailPane from "./plot/plot_detail_pane";
import AllocatePlotPane from "./plot/allocate_plot";
import ImportPartiesPane from "../add/import_parties";

export default class PartiesAllocationPane extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            data: []
        }
        this.loadData = this.loadData.bind(this)
        this.handleImportClick = this.handleImportClick.bind(this)
    }

    componentDidMount() {
        this.loadData()
    }


    render() {

        return (<div className={'row'}>
            <div className={'col col-sm-12'} style={{padding:0}}>
                <div style={{padding: '16px', background: '#efefef', position: 'sticky', top: 0, zIndex: 2}}>
                     <span style={{fontSize: '16px'}}>
                        <span className={'fa fa-users'} style={{marginRight: '8px'}}/>
                        Parties Allocation
                    </span>



                    <span style={{fontSize: '12px', float: 'right'}}>
                        <span className={'fa fa-history'} style={{marginRight: '11px', marginLeft: '4px'}}/>Updated 28 Minutes Ago
                    </span>

                </div>

                <div style={{height: '60vh'}}>
                    <div style={{margin:'2% 0 8px 2%'}}>
                        <select style={{width:'10vw',marginLeft:'4px'}}>
                            <option>- Deed Plan -</option>
                            <option value={'vacant'}>Vacant</option>
                            <option value={'occupied'}>Occupied</option>
                        </select>

                        <button style={{float: 'right', margin: '0 4%'}} className={'btn submit'} onClick={this.handleImportClick}>
                            <span className={'fa fa-upload'}/>Import Parties
                        </button>
                        <button style={{float: 'right', margin: '0 4%'}} className={'btn submit'} onClick={()=>this.loadData(0)}>
                            <span className={'fa fa-refresh'}/>Refresh
                        </button>
                    </div>


                    <table className={'tb'} style={{width:'94%',margin:'2%'}}>
                        <thead>
                        <tr>
                            <th style={{width:'50px'}}>#.</th>
                            <th>Created Date</th>
                            <th>FullName</th>
                            <th>Party Role</th>
                            <th>Phone</th>
                            <th style={{width:'90px'}}>Plots</th>
                        </tr>
                        </thead>
                        <tbody>

                        {this.state.data.map((d,i)=>{
                            return(<tr key={i} className={'tr'} style={{cursor:'pointer'}} title={d.description}>
                                <td>
                                    <div style={{width:'14px',float:'left'}}>
                                        {i+1}.
                                    </div>
                                    <input type={'checkbox'} style={{marginLeft:'8px'}}/>
                                </td>
                                <td>{d.muda}</td>
                                <td>
                                    <b style={{color:'darkcyan'}}>{d.first_name + ' ' + d.middle_name + ' ' + d.last_name}</b>
                                </td>
                                <td>{d.role_name}</td>
                                <td>{d.phone}</td>
                                <td style={{textAlign:'center'}}>
                                    {d.plots.map((p,j)=>{
                                        return(<div key={j} className={'badge'} style={{float:'left',padding:'2px 0',marginRight:'2px'}}>{p}</div>)
                                    })}
                                </td>
                            </tr>)
                        })}
                        </tbody>
                    </table>
                </div>

            </div>


        </div>)
    }


    loadData() {
        try {
            Wait.show('Fetching Data....')
            ReadService.fetchParties(this.props.project.id).then(r=>{
                Wait.dismiss()

                console.log(r.data.results)
                this.setState({
                    data:r.data.results
                })
            })
        }catch (e) {
            console.log(e)
        }
    }

    handleImportClick() {
        PopDetail.show('Import Parties', <ImportPartiesPane project={this.props.project} loadData={this.loadData} key={new Date().getMilliseconds()}/>)
    }
}
